module.exports = __webpack_public_path__ + "img/mobile_menu_bj03.19f7c2b7.png";